async function loadTextFromFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = function (e) {
            resolve(e.target.result);
        };
        reader.onerror = reject;
        reader.readAsText(file);
    });
}
/**
 * Reads a geojson from file input.
 * Uses the files *.json, *.geojson.
 * @param filefield HTML File Field
 * @returns part of the layer configuration for a memory layer
 */
export async function geojsonFromFileInput(filefield) {
    const files = filefield.files;
    if (files.length >= 1) {
        const filelist = [];
        for (let i = 0; i < files.length; i++) {
            filelist.push(files[i]);
        }
        const geojsons = filelist.filter((file) => ["json", "geojson"].indexOf(file.name.split(".").slice(-1)[0]) > -1);
        if (geojsons.length > 0) {
            const geojson_string = await loadTextFromFile(geojsons[0]);
            const filename = geojsons[0].name.split(".").slice(0, 1)[0];
            const geojson = JSON.parse(geojson_string);
            return {
                data: geojson,
                title: filename,
                srid: -1,
            };
        }
        else {
            throw Error("no file");
        }
    }
}
//# sourceMappingURL=geojson.js.map